/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getPolicyMTA, addMTA } from '../../../../actions'
import {
    fetchCountries,
} from '../../../../actions'

/**
 * Import
 * - Page component
 */
import MTA from '../../../../components/pages/Policies/MTA/MTA'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        policy: state.mta.policy,
        policySubmit: state.mta.submit,
        countries: state.step00.countries,
    }
}

export default connect(
    mapStateToProps,
    {
        getPolicyMTA,
        addMTA,
        fetchCountries,
    }
)(MTA)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Policies/MTA/MTA.tsx